// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../../../generated-types'

import gql from 'graphql-tag'
export type AttachmentFragment = {
  __typename?: 'VenueDocument'
  name: string
  url: string
}

export type AttachmentsFragment = {
  __typename?: 'Venue'
  documents?: Array<{
    __typename?: 'VenueDocument'
    name: string
    url: string
  }> | null
}

export const AttachmentFragmentDoc = gql`
  fragment Attachment on VenueDocument {
    name
    url
  }
`
export const AttachmentsFragmentDoc = gql`
  fragment Attachments on Venue {
    documents {
      ...Attachment
    }
  }
  ${AttachmentFragmentDoc}
`
